import { type, type Type } from 'arktype';
import type { ReviewQueueSeverity, VerdictParams } from './review-queue.model';
import { utcInstantSchema } from './utc-instant.model';

export const MISSING_CLOCK_OUT_FINDING_KIND = 'missing_clock_out';
export const FINDING_JUSTIFICATION_MAX_LENGTH = 1000;

export interface LegalReference {
  act: string;
  article: string;
}

export const findingJustificationTextSchema = type('string').narrow(
  (text, ctx) =>
    (text.trim().length > 0 && text.length <= FINDING_JUSTIFICATION_MAX_LENGTH) ||
    ctx.mustBe(`a non-blank text of at most ${FINDING_JUSTIFICATION_MAX_LENGTH} characters`)
);

export interface FindingJustification {
  text: string;
  createdAt: string;
}

export const findingJustificationSchema: Type<FindingJustification> = type({
  text: findingJustificationTextSchema,
  createdAt: utcInstantSchema,
}).onUndeclaredKey('reject');

export interface Finding {
  key: string;
  kind: string;
  severity: ReviewQueueSeverity;
  legalReference: LegalReference | null;
  params: VerdictParams;
  justification?: FindingJustification;
  canJustify: boolean;
  canAmend: boolean;
}
